import { useParams } from 'react-router-dom';
import { getSiteId, useAppSelector } from '@la/services';
import { getLAHostnameParts } from '@la/utilities';
import { isGameActivity } from 'lib/utils/schedules/isGameActivity';
import { useGetSiteProgramQuery } from 'redux/services/programApi';
import {
  useGetProgramPermissionsQuery,
  useGetSingleActivityQuery,
} from 'redux/services/singleActivityApi';
import MainContent from 'domains/Shell/MainContent/MainContent';
import styles from './SingleActivityView.module.scss';
import SingleActivityViewDetails from './SingleActivityViewDetails/SingleActivityViewDetails';
import SingleActivityViewHeader from './SingleActivityViewHeader/SingleActivityViewHeader';
import SingleActivityViewLocation from './SingleActivityViewLocation/SingleActivityViewLocation';
import SingleActivityViewNavigation from './SingleActivityViewNavigation/SingleActivityViewNavigation';
import SingleActivityViewRsvpDetails from './SingleActivityViewRsvpDetails/SingleActivityViewRsvpDetails';
import SingleActivityViewSidePanel from './SingleActivityViewSidePanel/SingleActivityViewSidePanel';
import { useUserSummary } from './utils/useUserSummary';

export default function SingleActivityView() {
  const { activityId } = useParams();
  const siteId = useAppSelector(getSiteId);
  const actId = parseInt(activityId || '0');

  const { subdomain } = getLAHostnameParts();

  const { data: activity } = useGetSingleActivityQuery({
    siteId: siteId,
    activityId: actId,
    subdomain,
  });

  const isGame = isGameActivity(activity?.type);
  const { getUserSummary } = useUserSummary({
    activityId: activity ? activity.id : 0,
    isGame,
  });
  const userSummaries = getUserSummary();

  const { programId } = useParams();
  const { data: program } = useGetSiteProgramQuery(
    {
      siteId,
      programId: Number(programId),
    },
    { skip: !activity || !siteId }
  );

  const getLeagueProfileUrl = () => {
    if (program?.type !== 'league') {
      return '';
    }

    const sport = program.details.sport?.toLowerCase().replace(/\s+/g, '-');
    return `/leagues/${sport}/${program.id}`;
  };

  const { data: permissions } = useGetProgramPermissionsQuery(
    {
      programId: programId ? Number(programId) : 0,
      subdomain,
    },
    { skip: !programId }
  );

  const leagueProfileUrl = getLeagueProfileUrl();

  return (
    <MainContent>
      <div className={styles.container}>
        <div>
          <SingleActivityViewHeader activity={activity} program={program} />
          <SingleActivityViewNavigation leagueProfileUrl={leagueProfileUrl} />
          <SingleActivityViewDetails
            activity={activity}
            userSummaries={userSummaries}
          />
          {permissions?.viewRsvp ? (
            <SingleActivityViewRsvpDetails
              activity={activity}
              userSummaries={userSummaries}
            />
          ) : null}
          <SingleActivityViewLocation activity={activity} program={program} />
        </div>
        <SingleActivityViewSidePanel
          activity={activity}
          permissions={permissions}
          userSummaries={userSummaries}
        />
      </div>
    </MainContent>
  );
}
